<template>
  <b-container fluid>
    <b-row>
      <b-col lg="5" class="my-1">
        <b-form-group
          label="Filtrar"
          label-for="filter-input"
          label-cols-sm="1"
          label-align-sm="left"
          label-size="sm"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filter-input"
              v-model="filter"
              type="search"
              placeholder="Buscar"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col lg="6" class="my-1">
        <b-form-group
          label="Sort"
          label-for="sort-by-select"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          class="mb-0"
          v-slot="{ ariaDescribedby }"
        >
          <b-input-group size="sm">
            <b-form-select
              id="sort-by-select"
              v-model="sortBy"
              :options="sortOptions"
              :aria-describedby="ariaDescribedby"
              class="w-75"
            >
              <template #first>
                <option value="">-- none --</option>
              </template>
            </b-form-select>
            <b-form-select
              v-model="sortDesc"
              :disabled="!sortBy"
              :aria-describedby="ariaDescribedby"
              size="sm"
              class="w-25"
            >
              <option :value="false">Asc</option>
              <option :value="true">Desc</option>
            </b-form-select>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-table
      :items="items"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      :busy="isBusy"
      stacked="md"
      show-empty
      small
      @filtered="onFiltered"
    >
      <template #cell(actions)="row">
        <b-button size="sm" @click="info(row.item, $event.target)" class="mr-1">
          Editar Datos
        </b-button>
        <b-button size="sm" @click="startResetPass(row.item, $event.target)" class="mr-1">
          Reset Password
        </b-button>
        <b-button size="sm" @click="startDelete(row.item, $event.target)" class="mr-1">
          Eliminar
        </b-button>
      </template>
      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>&nbsp;&nbsp;  Loading...</strong>
        </div>
      </template>
    </b-table>
    <b-row>
      <b-col sm="5" md="6" class="my-1">
        <b-form-group
          label="Per page"
          label-for="per-page-select"
          label-cols-sm="6"
          label-cols-md="4"
          label-cols-lg="3"
          label-align-sm="right"
          label-size="sm"
          class="mb-0"
        >
          <b-form-select
            id="per-page-select"
            v-model="perPage"
            :options="pageOptions"
            size="sm"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col sm="7" md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    <div>
      <b-modal :id="infoModal.id" hide-footer centered @hide="resetInfoModal">
        <b-form @submit.prevent="handleSubmit">
          <b-form-group
            id="input-group-1"
            label="Nombre:"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              type="text"
              placeholder="Nombre"
              v-model="infoFormFirstName"
              :value="infoModal.content.lastName"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-2"
            label="Apellido:"
            label-for="input-2"
          >
            <b-form-input
              id="input-2"
              type="text"
              placeholder="Apellido"
              v-model="infoFormLastName"
              :value="infoModal.content.lastName"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-3"
            label="Email:"
            label-for="input-3"
          >
            <b-form-input
              id="input-3"
              type="email"
              placeholder="Email"
              v-model="infoFormEmail"
              :value="infoModal.content.email"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-4"
            label="Username:"
            label-for="input-4"
          >
            <b-form-input
              id="input-4"
              type="text"
              placeholder="Username"
              v-model="infoFormUsername"
              :value="infoModal.content.username"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-5"
            label="Nro. de Documento:"
            label-for="input-5"
          >
            <b-form-input
              id="input-5"
              type="text"
              placeholder="Nro. de Documento"
              v-model="infoFormDocumentNumber"
              :value="infoModal.content.documentNumber"
              maxlength=8
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-5"
            label="Forzar cambio de contraseña:"
            label-for="input-5"
          >
            <b-form-select
              v-model="infoFormForceUserChangePassword"
              :options="forceUserChangePasswordOptions"
              value-field="forceUserChangePassword"
              text-field="text"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            id="input-group-6"
            label="StateId:"
            label-for="input-6"
          >
            <b-form-select
              v-model="selectedStateId"
              :options="stateIdOptions"
              value-field="stateId"
              text-field="text"
            ></b-form-select>
          </b-form-group>
          <b-form-group label="Modulos:" v-slot="{ ariaDescribedby }">
            <b-form-checkbox
              v-model="allSelected"
              :indeterminate="indeterminate"
              aria-describedby="ariaDescribedby"
              aria-controls="options"
              @change="toggleAll"
            >
              {{ allSelected ? 'Un-select All' : 'Select All' }}
            </b-form-checkbox>
            <b-form-checkbox-group
              id="options"
              v-model="selectedModules"
              :options="options"
              :aria-describedby="ariaDescribedby"
              name="options"
              value-field="id"
              text-field="name"
            ></b-form-checkbox-group>
          </b-form-group>
          <b-button class="mt-3" type="submit" block variant="primary">Registrar datos</b-button>
        </b-form>
      </b-modal>
    </div>
    <div class="d-flex flex-row-reverse">
      <b-button style="position: fixed; bottom:40px; right: 10%;" pill size="sm" variant="primary" @click="info"><h1  class="h2 pt-1 text-white">&nbsp; + &nbsp;</h1></b-button>
    </div>
    <b-modal :id="'delete_modal'" hide-footer centered>
      <h5>Desea eliminar el usuario : {{this.infoFormFirstName}}</h5>
      <b-button class="mt-3" block variant="primary" @click="rowDelete">Eliminar</b-button>
    </b-modal>
    <b-modal :id="'resetpass'" hide-footer centered>
      <h5>Desea resetear el password del usuario : {{this.infoFormFirstName}}</h5>
      <b-button class="mt-3" block variant="primary" @click="resetpass">Reset Password</b-button>
    </b-modal>
  </b-container>
</template>
<script>
import axios from 'axios'
export default {
  dependencies: ['DynamicCallService', 'GenericService'],
  data() {
    return {
      isBusy: true,
      items: [],
      fields: [
        { key: 'userId', label: 'Id', sortable: true, sortDirection: 'asc' },
        { key: 'firstName', label: 'Nombre', sortable: true, sortDirection: 'desc' },
        { key: 'lastName', label: 'Apellidos', sortable: true, sortDirection: 'desc' },
        { key: 'email', label: 'Email', sortable: true },
        {
          key: 'stateId',
          label: 'StateId',
          formatter: (value, key, item) => {
            return value === 1 ? 'Activado' : 'Desactivado'
          },
          sortable: true,
          sortByFormatted: true,
          filterByFormatted: true,
        },
        { key: 'actions', label: 'Actions' },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15, { value: 100, text: 'Show a lot' }],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        content: {},
      },
      infoFormFirstName: '',
      infoFormLastName: '',
      infoFormEmail: '',
      infoFormUsername: '',
      infoFormDocumentNumber: '',
      infoFormId: '',
      infoFormForceUserChangePassword: 0,
      selected: [],
      selectedStateId: '',
      selectedModules: [],
      options: [],
      stateIdOptions: [
        { stateId: 1, text: 'Activado' },
        { stateId: 2, text: 'Desactivado' },
      ],
      forceUserChangePasswordOptions: [
        { forceUserChangePassword: 1, text: 'Si' },
        { forceUserChangePassword: 0, text: 'No' },
      ],
      allSelected: false,
      indeterminate: false,
    }
  },
  computed: {
    sortOptions() {
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    },
  },
  beforeMount() {
    this.loadModules()
  },
  mounted() {
    this.loadData()
  },
  methods: {
    info(item) {
      this.infoModal.content = item
      this.selectedModules = item.modules
      this.selectedStateId = item.stateId || 2
      this.infoFormFirstName = item.firstName
      this.infoFormLastName = item.lastName
      this.infoFormEmail = item.email
      this.infoFormUsername = item.username
      this.infoFormDocumentNumber = item.documentNumber
      this.infoFormId = item.userId
      this.infoFormForceUserChangePassword = item.forceUserChangePassword || 0
      this.$root.$emit('bv::show::modal', this.infoModal.id)
    },
    toggleAll() {
      if (this.allSelected) {
        this.selectedModules = Array.from({ length: this.options.length }, (_, i) => i + 1)
      } else {
        this.selectedModules = []
      }
    },
    resetInfoModal() {
      this.infoModal.content = {}
      this.allSelected = false
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    hideModal() {
      this.$refs['info-modal'].hide()
    },
    handleSubmit(e) {
      e.preventDefault()
      const datarow = {
        userId: this.infoFormId,
        firstName: this.infoFormFirstName,
        lastName: this.infoFormLastName,
        email: this.infoFormEmail,
        username: this.infoFormUsername,
        documentNumber: this.infoFormDocumentNumber,
        modules: this.selectedModules || [],
        stateId: this.selectedStateId,
        forceUserChangePassword: this.infoFormForceUserChangePassword,
      }
      this.infoModal.content = datarow
      const newrow = this.items.find(element => element.userId === datarow.userId) || null
      newrow === null ? this.rowPost(datarow) : this.rowPut(datarow)
      this.$nextTick(() => {
        this.$bvModal.hide('info-modal')
        this.allSelected = false
      })
      this.totalRows = this.items.length
    },
    async rowPut(datarow) {
      await this.putUser(datarow)
      await this.loadData()
    },
    async rowPost(datarow) {
      const newid = 1 + this.items[this.items.length - 1].userId
      datarow = { ...datarow, userId: newid }
      await this.postUser(datarow)
      await this.loadData()
    },
    startDelete(item) {
      this.infoFormId = item.userId
      this.infoFormFirstName = item.firstName
      this.$root.$emit('bv::show::modal', 'delete_modal')
    },
    async rowDelete() {
      await this.deleteUser(this.infoFormId)
      await this.loadData()
      this.$nextTick(() => {
        this.$bvModal.hide('delete_modal')
      })
    },
    startResetPass (item) {
      this.infoFormId = item.userId
      this.infoFormFirstName = item.firstName
      this.$root.$emit('bv::show::modal', 'resetpass')
    },
    async resetpass () {
      try {
        await axios.put(`${process.env.VUE_APP_API_URL}/users/reset/${this.infoFormId}`)
        await this.loadData()
        this.$notification.success({
          message: 'OK',
          description: 'Reset Password se realizo correctamente',
        })
      } catch (err) {
        this.$notification.warning({
          message: 'ERROR',
          description: 'Reset Password no se realizo correctamente',
        })
      }
      this.$nextTick(() => {
        this.$bvModal.hide('resetpass')
      })
    },
    async loadModules () {
      try {
        const modulos = await this.GenericService.get('/maintenance/modules/list-all')
        this.options = modulos
      } catch (err) {
        this.$notification.warning({
          message: 'ERROR',
          description: 'El campo Modulos no fueron cargado correctamente',
        })
      }
    },
    async loadData () {
      try {
        this.isBusy = true
        const rows = await this.GenericService.get('/users/all-users')
        if (rows.length > 0) {
          this.items = rows
          this.totalRows = this.items.length
          this.isBusy = !this.isBusy
        } else {
          this.$notification.warning({
            message: 'Error',
            description: 'Los datos no fueron cargados correctamente',
          })
        }
      } catch (err) {
        this.$notification.warning({
          message: 'ERROR',
          description: 'Los datos no fueron cargados correctamente',
        })
      }
    },
    async postUser(datarow) {
      try {
        const resp = await this.GenericService.myPost('/users/create-user', {
          firstName: datarow.firstName,
          lastName: datarow.lastName,
          email: datarow.email,
          stateId: datarow.stateId,
          username: datarow.username,
          documentNumber: datarow.documentNumber,
          modules: datarow.modules,
          forceUserChangePassword: datarow.forceUserChangePassword,
        })
        this.$notification.success({
          message: 'OK',
          description: resp.data.message || 'Fue registrado correctamente',
        })
      } catch (err) {
        this.$notification.warning({
          message: 'Error',
          description: err.response.data.message || 'No fue registrado correctamente',
        })
      }
    },
    async putUser(datarow) {
      try {
        await axios.put(`${process.env.VUE_APP_API_URL}/users/${datarow.userId}/update`, {
          firstName: datarow.firstName,
          lastName: datarow.lastName,
          email: datarow.email,
          stateId: datarow.stateId,
          username: datarow.username,
          documentNumber: datarow.documentNumber,
          modules: datarow.modules,
          forceUserChangePassword: datarow.forceUserChangePassword,
        })
        this.$notification.success({
          message: 'OK',
          description: 'Actualizado correctamente',
        })
      } catch (err) {
        this.$notification.warning({
          message: 'ERROR',
          description: err.response.data.message, // || 'No fue actualizado correctamente',
        })
      }
    },
    async deleteUser(deleteId) {
      try {
        await axios.delete(`${process.env.VUE_APP_API_URL}/users/${deleteId}`)
        this.$notification.success({
          message: 'OK',
          description: 'Eliminado correctamente',
        })
      } catch (err) {
        this.$notification.warning({
          message: 'ERROR',
          description: 'No fue eliminado',
        })
      }
    },
  },
}
</script>
<style>
.AddButton {
position: fixed;
bottom:40px;
}
</style>
